import React, { useState,useRef, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import './Home.css';
import Vertical from './vertical.mp4';
import Horizontal from './horizontal.mp4';
import Client1 from './Client1.mp4'
import { Link } from 'react-router-dom';
import emailjs from 'emailjs-com';
import AOS from 'aos';
import 'aos/dist/aos.css';
// Debounce function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
const currentYear = new Date().getFullYear(); // Gets the current year

function Home() {
  useEffect(() => {
    AOS.init({
      duration: 1200, // values from 0 to 3000, with step 50ms
      once: false,
      threshold: 0.1, // whether animation should happen only once - while scrolling down
    });
  }, []);


  const form = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.2,
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Using debounce function to wrap handleResize with a 250ms delay
    const debouncedHandleResize = debounce(handleResize, 250);

    window.addEventListener('resize', debouncedHandleResize);
    return () => window.removeEventListener('resize', debouncedHandleResize);
  }, []);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");


  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log(form.current);
    emailjs
      .sendForm(
        "service_4uod01n", // from EmailJS dashboard
        "template_5288e2r", // from EmailJS dashboard
        form.current,
        "2swz86Fwys2PSHIJK"
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          // Reset form after successful submission
          setName("");
          setEmail("");
          setPhone("");
          setMessage("");
        },
        (error) => {
          console.log("FAILED...", error);
        }
      );
    // Reset form values
    setName("");
    setEmail("");
    setPhone("");
    setMessage("");

    

  };
  return (
    <div className="home">
      {isMobile ? (
        <video  autoPlay loop muted playsInline src={Vertical} />
      ) : (
        <video  autoPlay loop muted playsInline  src={Horizontal} />
      )}

      <div className="event-heading" ref={ref}>
        <h2 className={`${inView ? 'animate' : ''}`}>Explore Our Events</h2>
        
      </div>

      <div className="card-section">
        <Link to="/weddings" className="card card1" data-aos='fade-up'>
          <h3>Weddings</h3>
          <p>Experience the enchantment of matrimonial bliss in our bespoke wedding events.</p>
        </Link>
        <Link to="/birthdays" className="card card2" data-aos='fade-up'>
          <h3>Birthdays</h3>
          <p>Make every birthday unforgettable with our unique celebration ideas and themes.</p>
        </Link>
        <Link to="/babyshower" className="card card3" data-aos='fade-up'>
          <h3>Baby Showers</h3>
          <p>Celebrate the upcoming arrival with joyous festivities tailored for expecting families.</p>
        </Link>
      </div>

      <div className="card-section">
        <Link to="/collegefest" className="card card4" data-aos='fade-up'>
          <h3>College Fests</h3>
          <p>Dive into the vibrancy of college spirit with events that showcase talent, creativity, and unity.</p>
        </Link>
        <Link to= "/corporateevent" className="card card5"data-aos='fade-up'>
          <h3>Corporate Events</h3>
          <p>Engage and inspire your team with corporate events designed for team building and corporate culture.</p>
        </Link>
        <Link to="/schoolevent" className="card card6" data-aos='fade-up'>
          <h3>School Events</h3>
          <p>Explore a world of learning and fun with our educational and entertaining school event programs.</p>
        </Link>
      </div>
      <div className="client-home">
        <h2> Our Clients Share Their Experiences</h2>

         <div className="onlyvideos">
    <video controls src={Client1} data-aos='fade-right' />
    <video controls src={Client1}  data-aos='fade-down'/>
    <video controls src={Client1}  data-aos='fade-left'/>
  </div>
       
      </div>
      <div className="home-form-query" data-aos='fade-right'>
              <h1 className='form-heading'>Get In Touch ✍️</h1>

              <form onSubmit={handleFormSubmit} ref={form}>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Name"
                  required
                  name="name"
                />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  required
                  name="email"
                />
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Phone No"
                  required
                  name="phone"
                />
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Message"
                  required
                  name="purpose"
                ></textarea>

                <button type="submit">Submit</button>
              </form>
            </div>
      <div className="home-footer">
        <div className="AboutUs">
          <h3>About Us</h3>
          <p>At Dazzzling Sphere, we bring dreams to life through our bespoke event planning services. Based in New Delhi, we specialize in creating unforgettable experiences for any occasion, from lavish weddings to corporate galas and intimate gatherings. Our team of dedicated professionals is passionate about turning your vision into reality, ensuring every detail is meticulously crafted to reflect your unique style and personality. With Dazzzling Sphere, expect nothing less than exceptional service, innovative designs, and a seamless event that will leave a lasting impression on you and your guests. Let us make your next event not just an occasion, but a dazzzling celebration to remember.</p>
        </div>
        <div className="footer">
      {/* Render the copyright line with the current year */}
      <p>&copy; 2023 - {currentYear} Dazzzling Sphere. All rights reserved.</p>
    </div>
        {/* Additional footer content can be added here */}
        
      </div>
    </div>
  );
}

export default Home;
